import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router, Route, NavLink} from "react-router-dom";
import Instafeed from 'react-instafeed';
import Fade from 'react-reveal/Fade';

class OpenPositions extends Component {
  constructor (props) {
    super(props)
  }

  render() {
    const instafeedTarget = 'instafeed';

    // temp fix - empty container before filling.
    if(document.getElementById(instafeedTarget)) {
      document.getElementById(instafeedTarget).innerHTML = "";
    }

    return (
      <div>
        <Fade duration={400} delay={600}>
          <div className="instawrapper">
            <div className="content-wrapper instafeed">
              <div className="content">
                <h1 className="section-subheading">OPEN TEAM POSITIONS</h1>
                <div className="section-heading">BECOME PART OF THE</div>
                <div className="section-heading">UNIVERSE</div>
              </div>
            </div>
            <div className="icon-scroll"></div>
          </div>
        </Fade>
      </div>
    );
  }
}

export default OpenPositions;



// WEBPACK FOOTER //
// ./client/components/open-positions.jsx